import {
  getAccountName,
  getWorkspace,
} from '@/checkout-instore-legacy/utils/UrlUtils'
import isEmpty from 'lodash/isEmpty'
import {
  RenderExtensionLoaderNotFound,
  ExtensionPointNotFound,
} from './ExtensionError'
import * as Log from '../../../log/LogService'
import { LogEvent } from '../../../log/LogEvent'

const DEFAULT_TIMEOUT = 10 * 1000

interface CustomNodeJsGlobal extends NodeJS.Global {
  RenderExtensionLoader: any
}

declare const global: CustomNodeJsGlobal

export default class ExtensionLoader {
  private renderExtensionLoader: any
  private hasRenderExtensionLoader: boolean

  constructor() {
    this.hasRenderExtensionLoader =
      typeof global.RenderExtensionLoader !== 'undefined' &&
      global.RenderExtensionLoader !== null

    if (this.hasRenderExtensionLoader) {
      this.renderExtensionLoader = new global.RenderExtensionLoader({
        account: getAccountName(),
        workspace: getWorkspace(),
        path: '/checkout',
        timeout: DEFAULT_TIMEOUT,
      })
    }
  }

  load(): Promise<any> {
    if (!this.hasRenderExtensionLoader) {
      Log.error(LogEvent.EXTENSION_LOADER_NOT_FOUND)
      throw RenderExtensionLoaderNotFound
    }

    return this.renderExtensionLoader.load()
  }

  private hasExtensionPoint(appName: string) {
    if (!this.hasRenderExtensionLoader) {
      Log.error(LogEvent.EXTENSION_LOADER_NOT_FOUND)
      throw RenderExtensionLoaderNotFound
    }

    return !isEmpty(this.renderExtensionLoader.runtime.extensions[appName])
  }

  render(
    element: HTMLElement,
    appName: string,
    appProps: Record<string, any>
  ): Promise<any> {
    if (!this.hasRenderExtensionLoader) {
      Log.error(LogEvent.EXTENSION_LOADER_NOT_FOUND)
      throw RenderExtensionLoaderNotFound
    }

    if (!this.hasExtensionPoint(appName)) {
      Log.error(LogEvent.EXTENSION_POINT_NOT_FOUND)
      throw ExtensionPointNotFound
    }

    return this.renderExtensionLoader.render(appName, element, appProps)
  }
}
